import { render, staticRenderFns } from "./VoucherProductQr.vue?vue&type=template&id=2530c958&"
import script from "./VoucherProductQr.vue?vue&type=script&lang=js&"
export * from "./VoucherProductQr.vue?vue&type=script&lang=js&"
import style0 from "./VoucherProductQr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports